<template>
  <section class="quick-links">
    <h3 class="the-footer-heading">Быстрые ссылки</h3>
    <nav class="quick-links-navigation">
      <ul class="quick-links-main">
        <li
          v-for="link in quickLinks"
          v-bind:key="link.to"
        >
          <router-link v-bind:to="link.to">{{ link.text }}</router-link>
          <ul
            class="quick-links-sub"
            v-if="link['sub-links'] && link['sub-links'].length > 0">
            <li
              v-for="subLink in link['sub-links']"
              v-bind:key="subLink.to"
            >
              <router-link v-bind:to="subLink.to">{{ subLink.text }}</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </section>
</template>

<script>
export default {
  name: 'QuickLinks',
  data: function () {
    return {
      quickLinks: [
        {
          'to': '/catalog',
          'text': 'Каталог золото',
          'sub-links': [
            {
              'to': '/catalog/weddingrings',
              'text': 'Обручальные кольца'
            },
            {
              'to': '/catalog/rings',
              'text': 'Кольца'
            },
            {
              'to': '/catalog/earrings',
              'text': 'Серьги'
            },
            {
              'to': '/catalog/pendants',
              'text': 'Кулоны, кресты'
            }
          ]
        },
        {
          'to': '/catalogsilver',
          'text': 'Каталог серебро',
          'sub-links': [
            {
              'to': '/catalogsilver/pendantssilver',
              'text': 'Кулоны, кресты'
            },
            {
              'to': '/catalogsilver/ringssilver',
              'text': 'Кольца'
            },
            {
              'to': '/catalogsilver/earringssilver',
              'text': 'Серьги'
            },
            {
              'to': '/catalogsilver/braceletswithcharms',
              'text': 'Браслеты с шармами'
            }
          ]
        },
        {
          'to': '/exclusive',
          'text': 'Эксклюзив'
        },
        {
          'to': '/repair',
          'text': 'Ремонт'
        },
        {
          'to': '/about',
          'text': 'О компании'
        },
        {
          'to': '/tojewelers',
          'text': 'Ювелирам'
        },
        {
          'to': '/',
          'text': 'Главная'
        },
        {
          'to': '/sitemap',
          'text': 'Карта сайта'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
  .quick-links {
    &-main { margin: 0; }

    &-main > li {
      display: block;
      margin-bottom: 5px;
    }

    &-sub {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin-top: 5px;

      & > li {
        flex: 0 0 auto;
        margin: 0 10px 5px;

        & > a {
          color: $default-text-color;
          &:hover { color: $default-link-color; }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-footer/QuickLinks.vue